module.exports = __webpack_public_path__ + "img/bg-yellow.d4d0010c.png";